"use strict";

module.exports = {
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESCAPE: 27,
    SPACE: 32,
    END: 35,
    HOME: 36,
    LEFT_ARROW: 37,
    UP_ARROW: 38,
    RIGHT_ARROW: 39,
    DOWN_ARROW: 40
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next-util@0.7.0@@alicd/next-util/lib/key-code.js
// module id = 681
// module chunks = 0